import axios from 'axios';

export const apiURL = process.env.NODE_ENV === 'production'
  ? process.env.REACT_APP_PROD_API_URL || ''
  : process.env.REACT_APP_DEV_API_URL || '';

const devVKUserID = process.env.REACT_APP_DEV_VK_USER_ID || '1';

export function b64EncodeUnicode(value) {
  return btoa(unescape(encodeURIComponent(value)));
}

function buildLaunchURL() {
  const currentURL = new URL(window.location.href);
  if (currentURL.searchParams.get('vk_user_id')) {
    return currentURL.toString();
  }
  if (process.env.NODE_ENV !== 'production') {
    currentURL.searchParams.set('vk_user_id', devVKUserID);
    currentURL.searchParams.set('vk_platform', currentURL.searchParams.get('vk_platform') || 'desktop_web');
  }
  return currentURL.toString();
}

export function createURL(path) {
  const launchParams = b64EncodeUnicode(buildLaunchURL());
  if (!apiURL) {
    return `${path}${path.includes('?') ? '&' : '?'}p=${launchParams}`;
  }
  const url = new URL(apiURL + path);
  return `${url.toString()}${url.search ? '&' : '?'}p=${launchParams}`;
}

export const client = axios.create();
